import { TenantProvider } from '../../context/TenantContext';
import Header from './Header';
import Footer from './Footer';

const Layout = ({ children }) => {
  return (
    <TenantProvider>
      <div className="app-wrapper">
        <Header />
        <main className="flex-grow-1">{children}</main>
        <Footer />
      </div>
    </TenantProvider>
  );
};

export default Layout;
